export {
  systemApplicationListScreen,
  systemApplicationDetailScreen,
} from './system-application.screen';
export {
  systemApplicationListSearch,
  systemApplicationDetailSearch,
} from './system-application.search';
export { loadSystemApplicationMessages } from './system-application.catalog';
export const loadSystemApplicationScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadSystemApplicationGuides = () => import('./system-application.guide');
